import { WorkSheetLogModelType } from '@teinor/erp/types/company/order/sell/workSheet/workSheetLog'
import { InputTableLayoutData } from '../../../../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import OrderStatusBar from '../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderStatusBar'
import { getOrderStatusBarType } from '../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderStatusBar/functions'
import { TwinDictionary } from '../../../../../../../../../utils/globals/dictionary'
import useTwinTranslation from '../../../../../../../../../utils/hooks/useTwinTranslation'
import { displayDate } from '../../../../../../../../../utils/globals/date'
import { Fragment } from 'react'
import OrderStatusBarDropDown from '../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderStatusBarDropDown'
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons'
import { faClock } from '@fortawesome/pro-light-svg-icons'
import { workSheetStatusInversed } from '@teinor/erp/types/company/order/sell/workSheet'


interface WorkSheetStatusBarProps extends WorkSheetCreateStatusBarProps {}

const WorkSheetStatusBar: React.FC<WorkSheetStatusBarProps> = ({ completeData}) => {
    const { statuses } = useCreateStatusBar({ completeData })
    const currentOrderStatus = parseInt(completeData?.header?.status)
    return (
        <OrderStatusBar statuses={statuses} currentOrderStatus={currentOrderStatus} getOrderStatusBarType={getOrderStatusBarType} />
    )
}

export interface WorkSheetCreateStatusBarProps {
    completeData: InputTableLayoutData | null
}

const useCreateStatusBar = ({ completeData }: WorkSheetCreateStatusBarProps) => {
    const { t } = useTwinTranslation()
    const WorkSheetLogs = completeData?.header?.WorkSheetLogs
    let statuses: TwinDictionary[] = []
    const dictWorkSheetLogs: TwinDictionary = {}
    for (const log of WorkSheetLogs) {
        if (!dictWorkSheetLogs[log.logType]) {
            dictWorkSheetLogs[log.logType] = [log]
        } else {
            dictWorkSheetLogs[log.logType] = [...dictWorkSheetLogs[log.logType], log]
        }
    }
    statuses.push({
        id: -1,
        name: t('created', 'Creado'),
        logType: 0,
        color: 'bg-green-43',
        icon: faCheckCircle,
        className: 'text-green-43',
        renderMessage: dictWorkSheetLogs[0]?.length ? <RenderLogMessage logs={dictWorkSheetLogs[0] || []} /> : null
    })
    statuses.push(
        {
            id: 0,
            name: t('working', 'Trabajando'),
            logType: 2,
            color: 'bg-orange-DE',
            icon: faClock,
            className: 'text-orange-DE',
            extraClassName: 'border border-orange-DE',
            renderMessage: null
        }
    )
    statuses.push({
        id: 1,
        name: t('finalized', 'Finalizado'),
        logType: 3,
        color: 'bg-green-43',
        icon: faCheckCircle,
        className: 'text-green-43',
        renderMessage: dictWorkSheetLogs[2]?.length ? <RenderLogMessage logs={dictWorkSheetLogs[2] || []} /> : null
    })

    return { statuses }
}

interface RenderLogMessageProps {
    logs: WorkSheetLogModelType[]
}

const RenderLogMessage: React.FC<RenderLogMessageProps> = ({ logs }) => {
    const { tVars } = useTwinTranslation()
    const renderMessage: JSX.Element[] = []
    for (const log of logs) {
        const myExtraData = log?.extraData ? JSON.parse(log?.extraData) : null
        const options = { employeeTrigger: log.EmployeeTrigger?.fullname_short || '', date: displayDate(new Date(log.createdAt)), full_assigned_number: myExtraData?.full_assigned_number || null, 'interpolation': { 'escapeValue': false }}
        const dictWorkSheetLogsMessages: TwinDictionary = {
            0: myExtraData?.SellInvoiceId ?
                tVars('createdWorkSheetBySellInvoiceDateLogMessage', '{{employeeTrigger}} creó la hoja de trabajo a partir de la factura {{full_assigned_number}} el {{date}}', options) :
                myExtraData?.SellDeliveryNoteId ?
                    tVars('createdWorkSheetBySellDeliveryNoteDateLogMessage', '{{employeeTrigger}} creó la hoja de trabajo a partir del albarán {{full_assigned_number}} el {{date}}', options)
                    : tVars('createdWorkSheetBySellOrderDateLogMessage', '{{employeeTrigger}} creó la hoja de trabajo a partir del pedido {{full_assigned_number}} el {{date}}', options),
            1: '',
            2: tVars('finalizedWorkSheetLogMessage', '{{employeeTrigger}} marcó la hoja de trabajo como finalizada el {{date}}', options),
        }
      
        if (dictWorkSheetLogsMessages[log.logType]) {
            renderMessage.push(<div className='my-5' key={log.id} > {dictWorkSheetLogsMessages[log.logType]} </div>)
        }
    }
    if (!renderMessage.length) {
        return null
    }
    return (<Fragment>{renderMessage}</Fragment>)
}

export const WorkSheetStatusBarNew: React.FC<WorkSheetStatusBarProps> = ({ completeData }) => {
    const { statuses } = useCreateStatusBar({ completeData })
    const currentOrderStatus = parseInt(completeData?.header?.status)
    return (
        <OrderStatusBarDropDown statuses={statuses} currentOrderStatus={currentOrderStatus} getOrderStatusBarType={getOrderStatusBarType} isAccepted={currentOrderStatus === workSheetStatusInversed['finished']} />
    )
}

export default WorkSheetStatusBar